import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "@/app/hooks";
import { RootState } from "@/app/rootReducer";
import { fetchCampaignStatusMetadataAction } from "../slices/campaignStatusMetadataSlice";

export function useCampaignStatusMetadata() {
  const dispatch = useAppDispatch();

  const { metadata, loading, error } = useSelector(
    (state: RootState) => state.campaignStatusMetadata,
  );

  useEffect(() => {
    dispatch(fetchCampaignStatusMetadataAction());
  }, [dispatch]);

  return {
    metadata,
    loading,
    error,
  };
}
